import script from "./InitialConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./InitialConfiguration.vue?vue&type=style&index=0&id=770f42df&scoped=true&lang=sass"

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770f42df"]])

export default __exports__